import {
    ComponentInjector,
    ComponentService,
    ComponentElements,
    ComponentSelector,
    ComponentSelectors,
    ComponentObject,
    Inject,
    UIComponent,
    I18N
} from '@atypon/ui-utils'

import {releasedAssetsPath} from '../../../js/_utlis';

class Texts extends ComponentObject {}

class ClassList extends ComponentObject {}

class Selectors extends ComponentSelectors {
    numericMetrics = new ComponentSelector('.numeric-metrics-container', 'document');
    sideBarMetrics = new ComponentSelector('.sidebar-metric-container', 'document');
    toolbarMetrics = new ComponentSelector('.toolbar-metric-container', 'document');
    mentionList = new ComponentSelector('.mention-list-container', 'document');

}

class Elements extends ComponentElements<Selectors> {
    numericMetrics: HTMLElement[] = [];
    sideBarMetrics: HTMLElement[] = [];
    toolbarMetrics: HTMLElement[] = [];
    mentionList: HTMLElement[] = [];
}

interface ArticleMetrics extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class ArticleMetrics implements UIComponent {
    @Inject()
    protected i18n: I18N;

    constructor() {}

    async initialize(): Promise<void> {
        await this.initializeTranslations();
        await this.initializeSidebarClass();
        await this.initializeNumericClass();
        await this.initializeToolbarClass();
        await this.initializeMentionListClass();
    }

    addEventListeners(): void {}

    async initializeTranslations(): Promise<void> {
        (window as any).__webpack_public_path__ = releasedAssetsPath();
        this.elements.initialize();
        await this.i18n.initialize();
        UX.i18n = this.i18n;
    }

    async initializeSidebarClass(): Promise<void> {
        if (this.elements.sideBarMetrics.length > 0) {
            const { default: SideBarMetric } = await import('./sidebar-metric');
            this.elements.sideBarMetrics.forEach((item, index) => {
                UX.sidebarMetrics = new SideBarMetric(item, index);
                UX.sidebarMetrics.initialize();
            });
        }
    }

    async initializeNumericClass(): Promise<void> {
        if(this.elements.numericMetrics.length > 0) {
            const { default: NumericMetric } = await import('./numeric-metric');
            this.elements.numericMetrics.forEach((item, index) => {
                UX.numericMetrics = new NumericMetric(item, index);
                UX.numericMetrics.initialize();
            }); 
        }
    };

    async initializeToolbarClass(): Promise<void> {
        if (this.elements.toolbarMetrics.length > 0) {
            const { default: ToolbarMetric } = await import('./toolbar-metric');
            this.elements.toolbarMetrics.forEach((item, index) => {
                UX.toolbarMetrics = new ToolbarMetric(item, index);
                UX.toolbarMetrics.initialize();
            });
        }
    }

    async initializeMentionListClass(): Promise<void> {
        if(this.elements.mentionList.length > 0) {
            const { default: MentionListMetrics } = await import('./mention-list');
            this.elements.mentionList.forEach((item, index) => {
                UX.mentionList = new MentionListMetrics(item, index);
                UX.mentionList.initialize();
            });
        }
    }
}

export default ArticleMetrics;

export {
    Elements as ArticleMetricsElements,
    Selectors as ArticleMetricsSelectors,
    ClassList as ArticleMetricsClassList,
    Texts as ArticleMetricsTexts
}